import React, { useEffect, useRef, useState } from "react";
import { fetchgrouptripstour } from "../services/Grouptripstourlist";
import { API_BASE } from "../api/apiConfig";

const Homeupcominggrouptrips = () => {
  const [meetups, setMeetups] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchgrouptripstour();
      if (res?.status && Array.isArray(res.data)) {
        setMeetups(res.data);
      }
    };
    loadData();
  }, []);


   /* ================= HELPERS ================= */
  const parseCategories = (category) => {
    if (!category) return [];
    try {
      const parsed = JSON.parse(category);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  /* ================= FILTER DATA ================= */

  const countries = [
    "All",
    ...new Set(meetups.map((m) => m.country).filter(Boolean)),
  ];

  const cities = [
    "All",
    ...new Set(
      meetups
        .filter(
          (m) => activeCountry === "All" || m.country === activeCountry
        )
        .map((m) => m.city)
        .filter(Boolean)
    ),
  ];

  const filteredMeetups = meetups.filter((m) => {
    if (activeCountry !== "All" && m.country !== activeCountry) return false;
    if (activeCity !== "All" && m.city !== activeCity) return false;
    return true;
  });

  /* ================= SLIDER SCROLL ================= */

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "next" ? 350 : -350,
      behavior: "smooth",
    });
  };

  return (
    <section className="relative w-full bg-white py-10 md:py-14 text-slate-800 meet-section " id="group-meet">
    <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl" />
    <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl" />
    <div className="container relative z-10 mx-auto px-4 sm:px-5 md:px-6">
        <div className="mb-6 md:mb-8">
            <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
                <div>
                <div className="mb-2 md:mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-sm md:text-base font-medium text-primary hover-lift">
                    <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft" />
                    Group Adventures
                </div>
                <h2 className="mb-1.5 md:mb-2 text-xl md:text-2xl font-bold tracking-tight text-slate-800">
                    Upcoming <span className="text-gradient">Group Trips</span>
                </h2>
                <p className="max-w-[700px] text-sm md:text-base text-slate-700">
                    Join fellow travelers on curated group trips across incredible
                    destinations. From mountain expeditions to beach getaways, adventure
                    awaits!
                </p>
                </div>
            </div>
        </div>

        <div className="mb-5 md:mb-6 custom-scroll">
            <div className="flex gap-1.5 md:gap-2 min-w-max pb-3 md:pb-0">
            {cities.map((city) => (
                <button
                key={city}
                onClick={() => setActiveCity(city)}
                className={`px-3 py-1.5 rounded-full text-sm transition-all ${
                  activeCity === city
                    ? "bg-primary text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {city}
              </button>
            ))}
            </div>
        </div>

        <div className="relative -mx-4 px-4 sm:-mx-5 sm:px-5 md:-mx-4 md:px-4">
            <button  onClick={() => scrollSlider("prev")}
                className="customPrevBtnMeet absolute -left-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-0"
                aria-label="Previous meetups"
            >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left h-4 w-4 md:h-5 md:w-5"
                >
                <path d="m15 18-6-6 6-6" />
                </svg>
            </button>
                <div
                    className="flex w-full gap-3 md:gap-4 overflow-x-auto pb-6 scrollbar-hide"
                    style={{ scrollbarWidth: "none" }}
                    >
                <div
                  ref={sliderRef}
                  className="flex w-full gap-3 md:gap-4 overflow-x-auto pb-6 scrollbar-hide"
                  style={{ scrollbarWidth: "none" }}
                >

                {filteredMeetups.map((item, i) => (
                    <a
                    className="group min-w-[280px] max-w-[85vw] md:min-w-[320px] md:max-w-[350px] flex-shrink-0 snap-start block"
                    href={`/GroupTripsDtl/${item.id}`}
                    >
                    <div className="border bg-card text-card-foreground overflow-hidden border-none shadow-lg hover:shadow-xl transition-all duration-300 rounded-xl h-full">
                    <div className="relative h-[220px] md:h-[240px] w-full overflow-hidden">
                        <img
                        alt={item.name}
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-500 group-hover:scale-105"
                        style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                        }}
                        src={
                          item.images
                            ? `${API_BASE}${item.images}`
                            : `${API_BASE}default.jpg`
                        }
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                          
                        {item.tage && Number(item.tage) !== 0 && (
                          <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-full bg-primary/90 px-2.5 py-1 shadow-sm backdrop-blur-sm">
                                <p className="flex items-center gap-1.5 text-xs font-medium text-white">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-tag h-3 w-3 text-white"
                                        >
                                        <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                        <path d="M7 7h.01" />
                                    </svg>
                                    {item.tage}
                                </p>
                                </div>
                            </div>
                        )}

                            <div className="absolute top-3 right-3">
                                <div className="rounded-full bg-white/90 px-2.5 py-1 shadow-sm backdrop-blur-sm">
                                <p className="flex items-center gap-1.5 text-xs font-medium text-slate-800">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-calendar h-3 w-3 text-primary"
                                        >
                                        <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                        <line x1={16} x2={16} y1={2} y2={6} />
                                        <line x1={8} x2={8} y1={2} y2={6} />
                                        <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    {item.duration} / {item.no_of_days} days
                                </p>
                                </div>
                            </div>
                            <div className="absolute bottom-0 left-0 right-0 p-4">
                                <h3 className="text-lg md:text-xl font-bold text-white mb-1 group-hover:text-primary/90 transition-colors">
                                {item.name}
                                </h3>
                                <div className="flex flex-wrap items-center gap-3 text-xs text-white/90">
                                <div className="flex items-center gap-1">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-map-pin h-3 w-3 text-primary"
                                        >
                                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                        <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span>{item.city}</span>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-3 bg-white">
                            <div className="flex items-center justify-between mb-2">
                                <div className="flex items-baseline gap-1.5">
                                <span className="text-lg font-bold text-slate-900">₹{item.charges}</span>
                                <span className="text-xs text-slate-500 line-through">₹{item.difficulties}</span>
                                </div>
                                <span className="text-xs font-bold text-green-600 bg-green-50 px-2 py-1 rounded">
                                ₹{item.difficulties - item.charges} Off
                                </span>
                            </div>
                            <div className="flex items-center gap-1.5 text-slate-600">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-calendar h-3 w-3 text-primary flex-shrink-0"
                                >
                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                <line x1={16} x2={16} y1={2} y2={6} />
                                <line x1={8} x2={8} y1={2} y2={6} />
                                <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1">
                                 {(() => {
                                let tourDates = [];

                                try {
                                  tourDates = item?.tour_date
                                    ? JSON.parse(item.tour_date)
                                    : [];
                                } catch (e) {
                                  tourDates = [];
                                }

                                return (
                                  <>
                                    {tourDates.slice(0, 3).map((date, index) => {
                                      // Remove weekday (Tuesday / Friday)
                                      const cleanDate = date.split("-")[0].trim();

                                      return (
                                        <span
                                          key={index}
                                          className="text-[10px] font-medium bg-slate-100 px-1.5 py-0.5 rounded"
                                        >
                                          {cleanDate}
                                        </span>
                                      );
                                    })}

                                    {tourDates.length > 3 && (
                                      <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                        +{tourDates.length - 3} more
                                      </span>
                                    )}
                                  </>
                                );
                              })()}
                                

                                </div>
                            </div>
                        </div>
                    </div>
                    </a>
                ))}

                    
                </div>
                </div>
            <button onClick={() => scrollSlider("next")}
                className="customNextBtnMeet absolute -right-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-0"
                aria-label="Next meetups"
            >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"
                >
                <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
        </div>

        <div className="mt-2 flex items-center justify-center gap-1 md:hidden">
            <div className="h-1.5 w-8 rounded-full bg-primary/30 animate-pulse-soft" />
            <div
                className="h-1.5 w-4 rounded-full bg-primary/60 animate-pulse-soft"
                style={{ animationDelay: "0.2s" }}
            />
            <div
                className="h-1.5 w-3 rounded-full bg-primary/30 animate-pulse-soft"
                style={{ animationDelay: "0.4s" }}
            />
        </div>
        <div className="mt-8 text-center">
            <a href="/grouptrips" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border hover:text-accent-foreground h-10 py-2 text-sm md:text-base border-primary/30 bg-transparent text-primary hover:bg-primary/10 px-4">
                View All Group Trips
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right ml-1.5 h-4 w-4 md:h-5 md:w-5"
                >
                <path d="m9 18 6-6-6-6" />
                </svg>
            </a>
        </div>
    </div>
</section>
  );
};

export default Homeupcominggrouptrips;
